import { YattaLinkBase, isYattaLinkBase } from './yatta-link-base';

export interface BlurCallbackLink extends YattaLinkBase {
  onBlur: () => void;
}

export function isBlurCallbackLink(value: unknown): value is BlurCallbackLink {
  return typeof value === 'object' && value !== null && 'onBlur' in value && typeof value.onBlur === 'function' && isYattaLinkBase(value);
}
